export const initialValues = {
  householdIncome: [],
  propertyInformation: {},
  attachments: {},
  application: {
    city: "Milwaukee",
    state: "Wisconsin",
  },
};
